module.exports = __webpack_public_path__ + "static/blockchain-development-min-a3446cb4965457a96ebce920e5b92ef9.jpg";